import ReactGA from 'react-ga4';

const GA_ID = 'G-9ZFRKKEYQ8';
export const COOKIE_CONSENT_KEY = 'cookie-consent-v1';

let initialized = false;

/** true solo si el visitante ha pulsado "Aceptar" en el banner de cookies */
export const hasAnalyticsConsent = (): boolean => {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY) === 'true';
  } catch {
    return false;
  }
};

/**
 * Carga Google Analytics SOLO si hay consentimiento (RGPD).
 * Las vistas de página las registra GA4 automáticamente (medición mejorada),
 * incluidas las navegaciones internas de la web.
 */
export const initGA = () => {
  if (initialized || !hasAnalyticsConsent()) return;
  ReactGA.initialize(GA_ID);
  initialized = true;
};

// Se mantiene por compatibilidad: GA4 ya cuenta las páginas solo, así no se duplican.
export const logPageView = (_path?: string) => {};

export const logEvent = (category: string, action: string, label?: string) => {
  if (!initialized) return;
  ReactGA.event({
    category,
    action,
    label
  });
};
